<template>
  <div>
    <img :style="placeLogoAtTheCenter()" src="./../assets/receiver-dark.png"/>
    <div class="code-container" >
      <p v-if="name!=='' && error===''" class="code-text">{{t('splash.use_code')}}: {{ name }}</p>
      <p v-else-if="error===''" class="code-text">{{ t('splash.connecting') }}</p>
      <p v-if="error!==''" class="code-text">{{error}}</p>
    </div>
  </div>
</template>
  
<script setup>
import eventBus from '../plugins/eventBus';
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useAppStore } from '@/stores/appStore'
import { useI18n } from 'vue-i18n'

defineOptions({
  name: 'SplashScreen'
})

const appStore = useAppStore()
const { t, locale } = useI18n()
const width = ref(window.innerWidth)
const height = ref(window.innerHeight)
const name = ref('')
const error = ref('')

onMounted(()=>{
  console.log('splash mounted')
  window.addEventListener('resize', handleResize)
  if(appStore.name!==''){
    name.value = appStore.name
  }
  // this event occurs when socket is connected
  eventBus.on('name', (data) => {
    console.log('Web receiver created with code '+data.name)
    appStore.setName(data)
    error.value = ''
    name.value = data.name
  })
   eventBus.on('error', (data) => {
    console.log('Can not create web receiver')
    error.value = 'Connection error'
    console.log(error.value)
  })
})

onBeforeUnmount(()=>{
  eventBus.off('name')
  eventBus.off('error')
  window.removeEventListener('resize', handleResize)
})

function placeLogoAtTheCenter(){
  const logoSize = Math.round(Math.min(width.value, height.value) / 2)
  let loaderCss = 'position:absolute;width:'+logoSize+'px;height:'+logoSize+'px;'
  loaderCss+='top:'+(height.value-logoSize)/2+'px;'
  loaderCss+='left:'+(width.value-logoSize)/2+'px;'
  return loaderCss
}

function handleResize() {
  width.value = window.innerWidth
  height.value = window.innerHeight
}

</script>
<style scoped>
.code-container {
  position: absolute;
  bottom: 30px;
  left: 10%;
  width: 80%;
  overflow: hidden;
}
.code-text{
  font-size: 2rem;
  color:#fff7b2
}
</style>

  
